import { useTranslate } from "@similarweb/i18n-provider";

import ChangeIndication from "app/components/ChangeIndication/ChangeIndication";
import { percentageFilter } from "app/filters/ngFilters";
import { EMPTY_COMPETITORS_COUNT, EMPTY_VALUE } from "app/pages/activation/components/HomeWithData/constants";
import { TIME_PERIOD } from "app/pages/activation/components/HomeWithData/ShareData/TrafficWidgets/MyTrafficShare/BodyByState/constants";
import { addPercentPoint } from "app/pages/activation/helpers/format";
import { DEFAULT_DECIMAL, FORMATTERS } from "app/common/benchmark/formatters";

import * as SC from "./styles";
import { WIDGET_MESSAGE } from "./texts";

const Empty = () => {
    const { translate } = useTranslate();

    return (
        <SC.Container>
            <SC.InfoSectionLeft>
                <SC.ShareOfVoice>{FORMATTERS.percentSign(EMPTY_VALUE, DEFAULT_DECIMAL)}</SC.ShareOfVoice>
                <SC.ChangeWrapper>
                    <ChangeIndication
                        className="customChangeIndication"
                        changeValue={`${addPercentPoint(percentageFilter()(EMPTY_VALUE, 2))} ${TIME_PERIOD}`}
                        isIncreasing={false}
                        isNotChanged={false}
                    />
                </SC.ChangeWrapper>
                <SC.Message>{translate(WIDGET_MESSAGE, { num: EMPTY_COMPETITORS_COUNT })}</SC.Message>
            </SC.InfoSectionLeft>
        </SC.Container>
    );
};

export default Empty;
